import { ErrorText } from 'modules/campaigns/editor/styles';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { useFormState, useWatch } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { SCHEDULE_CAMPAIGN_FORM_FIELDS } from '../ScheduleCampaignModal.constants';
import { RecurrenceFrequencyInputField } from '../ScheduleCampaignModal.styled';

export const RecurrenceFrequency = () => {
  const [recurrenceFrequency] = useWatch<Pick<ScheduleFormState, 'recurrenceFrequency'>>({
    name: ['recurrenceFrequency'],
  });

  const { errors } = useFormState<Pick<ScheduleFormState, 'recurrenceFrequency'>>({
    name: ['recurrenceFrequency'],
  });

  const { recurrenceFrequency: recurrenceFrequencyError } = errors;

  return (
    <FormField labelText="Re-run campaign every">
      <RecurrenceFrequencyInputField
        data-test={SCHEDULE_CAMPAIGN_FORM_FIELDS.RECURRENCE_FREQUENCY}
        name="recurrenceFrequency"
        Suffix={<div>{parseInt(recurrenceFrequency, 10) === 1 ? 'day' : 'days'}</div>}
        type="number"
      />
      {recurrenceFrequencyError?.message && (
        <ErrorText>{recurrenceFrequencyError.message}</ErrorText>
      )}
    </FormField>
  );
};
